import sc from 'styled-components';
import c from 'chroma-js';
import React from 'react';
import { Table } from 'antd';
import { BLUE, BLUE_DARK, WHITE, TABLE_ROW_SELECTED_TEXT, SELECTABLE_HIGHLIGHT_COLOR } from './styleConstants';

export default sc(Table)`  
  .ant-table-header { background-color: transparent; }
  .ant-table-thead > tr {
    background: transparent;
    border-bottom: 1px solid #ededed;
    & > th {
    background-color: transparent;
    font-weight: bold;
      color: #a4a4a4d9;
      border: 0;
    }
  }
  .ant-table-placeholder { border: 1px solid #ededed; }
  .ant-table-middle > .ant-table-content > .ant-table-scroll > .ant-table-header > table > .ant-table-thead > tr > th, .ant-table-middle > .ant-table-content > .ant { 
    padding-bottom: 6px;
  }
  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 0.125rem 0.75rem;
   }
  .ant-table-tbody {
    border: 1px solid #ededed;
    border-top: 0;
    background-color: #ffffff;
    & > tr {
      &.ant-table-row-selected {
        background-color: ${c(BLUE).alpha(0.025)};
        td {
    font-weight: BOLD;
    color: ${TABLE_ROW_SELECTED_TEXT};
    background-color: ${WHITE};
    input[type="text"] {
      color: ${TABLE_ROW_SELECTED_TEXT};
      border-color: ${TABLE_ROW_SELECTED_TEXT}
    } 
    button {
      border-color: ${TABLE_ROW_SELECTED_TEXT}
    }
  }
      }
      &.hover-style:hover {
        box-shadow: 0 8px 16px ${c(BLUE_DARK).alpha(0.15)}, 0 6px 12px rgba(0,0,0,0.3);
      }
      & > td {
        border-bottom: none;
        &.link-style{
          color: ${BLUE};
          text-decoration: underline;
        }
      }
    }
  }
  .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
    &:hover {
      background-color: transparent;
      color: ${BLUE};
      transition: unset;
      .ant-table-column-sorters::before {
      bottom: -1px;
        border-bottom: 3px solid ${c(BLUE).alpha(0.75)};
      }
    }
  }
  
  .ant-table-row-indent {
  display: none!important;
  }
  
  .ant-table-footer, ant-table-head, ant-table-head > tr  {
  padding: 0;
  background-color: transparent;
  }
  tbody tr:nth-child(even) {
    background-color: #fafafa;
  }
  
  ${({ hightlightSelectable }) => (hightlightSelectable ?
    `.ant-table-selection-column, .ant-table-thead .ant-table-selection-column  {
    background-color: ${SELECTABLE_HIGHLIGHT_COLOR}!important;
    border:  1px solid ${SELECTABLE_HIGHLIGHT_COLOR}!important;
  }` : '')}
`;
